import type { ContentPage } from "@/lib/content/types";

export const liveChat: ContentPage = {
  slug: "omni-channels/live-chat",
  template: "hrmsFeature",
  seo: {
    title: "Live Chat CRM - Convert Website Visitors in Real Time | GetBiz CRM",
    description:
      "Add live chat to your website with GetBiz CRM. Engage visitors instantly, capture leads, and sync every conversation to the contact record automatically.",
    keywords: [
      "live chat CRM",
      "website live chat software",
      "chat lead capture",
      "live chat support",
      "sales chat software",
      "chat to CRM",
    ],
    ogImage: "/assets/data/seoimages/live-chat.webp",
  },
  leaf: {
    hero: {
      caption: "Live Chat",
      title: "Turn Website Visitors Into Qualified Leads",
      description:
        "Engage visitors the moment they land with GetBiz CRM live chat — capture leads, route chats to the right rep, and save every conversation to the CRM automatically.",
      h1: "caption",
    },
    split: {
      title: "Real-time Chat That Feeds Your Pipeline",
      bullets: [
        { title: "Instant Engagement", description: "Greet visitors and answer in real time." },
        { title: "Lead Capture", description: "Create CRM leads from chats automatically." },
        { title: "Smart Routing", description: "Send chats to the right rep or team." },
        { title: "Chat History", description: "Every conversation saved on the record." },
      ],
      image: "/assets/images/img/product/crm/live-chat-lead-image.webp",
      imageAlt: "GetBiz CRM live chat",
    },
    cardsHeading: { title: "More Omni Channels", description: "Live Chat works with the rest of GetBiz CRM omni-channel." },
    cards: [
      { title: "Webforms", href: "/crm-software/omni-channels/webforms/", description: "Capture leads when chat is offline.", image: "/assets/images/img/product/crm/webform.webp", imageAlt: "CRM webforms" },
      { title: "Email", href: "/crm-software/omni-channels/email/", description: "Follow up chats with tracked email.", image: "/assets/images/img/product/crm/email.webp", imageAlt: "CRM email" },
      { title: "WhatsApp", href: "/crm-software/omni-channels/whatsapp/", description: "Move the chat to WhatsApp seamlessly.", image: "/assets/images/img/product/crm/whatsapp.webp", imageAlt: "CRM WhatsApp" },
      { title: "Social Media", href: "/crm-software/omni-channels/social-media/", description: "Handle social chats in one inbox.", image: "/assets/images/img/product/crm/social-media.webp", imageAlt: "CRM social media" },
    ],
    testimonials: { title: "Convert more web traffic", description: "See why teams add live chat with GetBiz CRM." },
    bookDemoTitle: "Add live chat to your website.",
    relatedBlogs: "slug",
    relatedBlogsKeyword: "live-chat-for-lead-generation, live-chat-best-practices",
    metaKey: "live-chat",
  },
  sections: [],
};
